import React, { useState, useEffect, useRef } from "react";
import { ListGroup, Button, Form, Offcanvas, } from "react-bootstrap";
import { PersonCircle, ArrowLeft, Plus } from "react-bootstrap-icons";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../constants";
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default function ChatMobile({
  setFile,
  setPreviewUrl,
  users,
  user,
  setUsers, 
  shelterId,
  userId, 
  lastMessages,
  messages,
  activeChat,
  handleSelectChat,
  handleUserSelect,
  setMessage,
  message,    
  handleFile,
  previewUrl,
  file,
  fromLanguage,
  toLanguage,
  setFromLanguage,
  setToLanguage,
  onBack,
   socket,          
  setMessages,     
  setLastMessages,
  receivedMessageCounts,

}) {
  const receiverId = activeChat; // or get it from props or state


  const [sendingStatus, setSendingStatus] = useState("idle");
  const [showUserList, setShowUserList] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
    const [shelters, setShelters] = useState([]);
    const [selectedShelterId, setSelectedShelterId] = useState('');
  const textareaRef = useRef(null);
  const messagesEndRef = useRef(null);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const fetchUsers = async (shelterIdToUse = shelterId) => {
    if (!user || !user.id) {
      console.warn("User is undefined or missing ID.");
      return;
    }
  
    try {
      const response = await axios.get(`${BASE_URL}/shelters/users/${shelterIdToUse}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      const filteredUsers = response.data.filter((u) => u._id !== user.id);
      setUsers(filteredUsers);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const fetchShelters = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/shelters`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setShelters(response.data);
    } catch (error) {
      console.error('Error fetching shelters:', error);
    }
  };
  useEffect(() => {
    fetchUsers();
    fetchShelters();
  }, []);
  // Declare filteredMessages BEFORE useEffect!
  const filteredMessages =
    messages?.filter(
      (msg) =>
        (msg.sender._id === userId && msg.receiver._id === activeChat) ||
        (msg.receiver._id === userId && msg.sender._id === activeChat)
    ) || [];

  // Declare activeUser BEFORE return JSX
  const activeUser = users.find((u) => u._id === activeChat);



useEffect(() => {
  if (sendingStatus === "sent") {
    const timer = setTimeout(() => {
      setSendingStatus("idle");
    }, 2000); // 2 seconds
    return () => clearTimeout(timer);
  }
}, [sendingStatus]);

useEffect(() => {
  if (messagesEndRef.current) {
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  }
}, [filteredMessages, activeChat]);




  // Scroll to bottom when filteredMessages change
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [filteredMessages]);

 const sendMessage = async (e) => {
  e.preventDefault();

  if ((message.trim() || file) && receiverId) {
    try {
      setSendingStatus("sending"); // <-- add sending status here

      const [senderRes, receiverRes] = await Promise.all([
        axios.get(`${BASE_URL}/users/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${BASE_URL}/users/${receiverId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      const formData = new FormData();
      formData.append("receiverId", receiverId);

      if (message.trim()) {
        formData.append("content", message.trim());
      }

      if (file) {
        formData.append("file", file);
      }

      formData.append("fromLang", fromLanguage);
      formData.append("toLang", toLanguage);

      const res = await axios.post(`${BASE_URL}/messages`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const savedMessage = res.data.data;

      const newMessage = {
        _id: savedMessage._id,
        content: savedMessage.content === "undefined" ? null : savedMessage.content,
        file: savedMessage.file || null,
        sender: {
          _id: senderRes.data._id,
          firstName: senderRes.data.firstName,
          lastName: senderRes.data.lastName,
          profilePhoto: senderRes.data.profilePhoto,
        },
        receiver: {
          _id: receiverRes.data._id,
          firstName: receiverRes.data.firstName,
          lastName: receiverRes.data.lastName,
          profilePhoto: receiverRes.data.profilePhoto,
        },
        timestamp: savedMessage.timestamp,
        isRead: false,
      };

      socket.emit("newMessage", newMessage);

      if (
        receiverId === newMessage.receiver._id ||
        receiverId === newMessage.sender._id
      ) {
        setMessages((prevMessages) => [...prevMessages, newMessage]);
      }

      setLastMessages((prevLastMessages) => {
        const updatedMessagesByContact = prevLastMessages.reduce((acc, message) => {
          const contactId =
            message.sender._id === userId ? message.receiver._id : message.sender._id;

          if (!acc[contactId] || new Date(message.timestamp) > new Date(acc[contactId].timestamp)) {
            acc[contactId] = message;
          }

          return acc;
        }, {});

        const contactId =
          newMessage.sender._id === userId
            ? newMessage.receiver._id
            : newMessage.sender._id;

        updatedMessagesByContact[contactId] = {
          ...newMessage,
        };

        return Object.values(updatedMessagesByContact);
      });

      setMessage("");
      setFile(null);
      setPreviewUrl(null);
      
      setSendingStatus("sent"); 
    } catch (error) {
      console.error("Error fetching user or sending message:", error);
      setSendingStatus("failed"); 
    }
  } else {
    console.error("Message or receiverId is missing");
  }
};


  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [message]);



  if (!activeChat) {

    return (
      <div className="container-fluid p-2 d-flex flex-column vh-100">
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
          <Button
            variant="light"
            onClick={() => {
              if (showUserList) {
                setShowUserList(false);
              } else {
                navigate(-1);
              }
            }}
          >
            <ArrowLeft className="me-2" />
          </Button>

          <h5 className="m-0">Chats</h5>
          <Button
            variant="primary"
            size="sm"
            onClick={() => setShowUserList((v) => !v)}
            aria-expanded={showUserList}
            aria-controls="user-list-collapse"
          ><FontAwesomeIcon icon={faPenToSquare} />
           
          </Button>
           
        </div>

        {showUserList ? (
        <Offcanvas
        show={showUserList}
        onHide={() => setShowUserList(false)}
        placement="end"
        backdrop={true}
        style={{ maxWidth: "300px" }}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>New Chat</Offcanvas.Title>
        </Offcanvas.Header>
      <Offcanvas.Body>
      <>
        <Form.Select
          className="mb-3"
          value={selectedShelterId}
          onChange={(e) => {
            const selectedId = e.target.value;
            setSelectedShelterId(selectedId);
            fetchUsers(selectedId);
          }}
        >
          <option value="">Select Shelter</option>
          {shelters
            .filter((shelter) => shelter._id !== user.shelterId)
            .map((shelter) => (
              <option key={shelter._id} value={shelter._id}>
                {shelter.name}
              </option>
            ))}
        </Form.Select>
      </>
    
    
        {/* Search input */}
        <Form.Control
          type="text"
          placeholder="Search user..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="mb-3"
        />
    
        {/* Users list */}
        <ListGroup>
          {users
            .filter((user) =>
              `${user.firstName} ${user.lastName}`
                .toLowerCase()
                .includes(searchTerm.toLowerCase())
            )
            .map((user) => (
              <ListGroup.Item
                key={user._id}
                action
                onClick={() => handleUserSelect(user._id)}
                className={user._id === activeChat ? "bg-gray-600 text-white rounded" : ""}
              >
                <div className="d-flex align-items-center">
                  {user.profilePhoto ? (
                    <img
                      src={user.profilePhoto}
                      alt={`${user.firstName} ${user.lastName}`}
                      className="rounded-circle me-3"
                      width="36"
                      height="36"
                    />
                  ) : (
                    <div
                      className="bg-gray-500 text-white d-flex justify-content-center align-items-center rounded-circle me-3"
                      style={{ width: "36px", height: "36px" }}
                    >
                      <PersonCircle size={36} />
                    </div>
                  )}
                  <div>
                    <p className="mb-0 fw-bold">
                      {user.firstName && user.lastName
                        ? `${user.firstName} ${user.lastName}`
                        : "Unknown"}
                    </p>
                  </div>
                  {user.isConnected && (
                    <div
                      className="rounded-circle bg-success ms-auto"
                      style={{ width: "10px", height: "10px" }}
                    />
                  )}
                </div>
              </ListGroup.Item>
            ))}
        </ListGroup>
    
      </Offcanvas.Body>
      </Offcanvas>
      
        ) : (
          <ListGroup className="flex-grow-1 overflow-auto">
            {lastMessages.length === 0 && (
              <p className="p-3 text-center">No chats yet</p>
            )}
            {[...lastMessages]
              .sort(
                (a, b) =>
                  new Date(b.createdAt || b.timestamp) -
                  new Date(a.createdAt || a.timestamp)
              )
              .map((lastMsg) => {
                const contactId =
                  lastMsg.sender._id === userId
                    ? lastMsg.receiver._id
                    : lastMsg.sender._id;
                const contact = users.find((u) => u._id === contactId);
                const receivedCount = receivedMessageCounts[contactId] || 0;

                return (
                  <ListGroup.Item
                  key={lastMsg._id}
                  action
                  onClick={() => handleSelectChat(contactId)}
                  className="d-flex align-items-center justify-content-between position-relative"
                >
                  <div className="d-flex align-items-center">
                    {contact?.profilePhoto ? (
                      <img
                        src={contact.profilePhoto}
                        alt={`${contact.firstName} ${contact.lastName}`}
                        className="rounded-circle me-2"
                        width={40}
                        height={40}
                      />
                    ) : (
                      <PersonCircle
                        size={40}
                        className="me-2 bg-gray-500 text-white rounded-circle"
                      />
                    )}
                
                    <div
                      className="text-truncate"
                      style={{ maxWidth: "120px" }}
                    >
                      <div className="d-flex align-items-center">
                        <strong style={{ marginRight: 6 }}>
                          {contact
                            ? `${contact.firstName} ${contact.lastName}`
                            : "Unknown User"}
                        </strong>
                        <span
                          className={`rounded-circle ${contact?.isConnected ? "bg-success" : "bg-gray-500"}`}
                          style={{ width: 10, height: 10, flexShrink: 0 }}
                        />
                      </div>
                      <div className="small text-truncate">
                        {lastMsg.content
                          ? lastMsg.content
                          : lastMsg.file
                          ? lastMsg.file.type.startsWith("image")
                            ? "📷 Image"
                            : lastMsg.file.type === "application/pdf"
                            ? "📄 PDF File"
                            : "📁 File"
                          : "No content"}
                      </div>
                    </div>
                  </div>
                
                  {/* Unread messages badge */}
                  {receivedCount > 0 && (
            <span
              className="badge bg-danger position-absolute"
              style={{ bottom: "10px", right: "6px" }}
            >
              {receivedCount}
            </span>
          )}
                </ListGroup.Item>
                
                  
                );
                
              })}
          </ListGroup>
        )}
          
      </div>
    );
  }

  return (
    <div className="container-fluid p-2 d-flex flex-column vh-100">
    <div className="border-bottom d-flex align-items-center p-2">
  <Button variant="light" onClick={onBack} className="me-2 d-md-none">
    <ArrowLeft size={24} />
  </Button>

  {activeUser?.profilePhoto ? (
    <img
      src={activeUser.profilePhoto}
      alt={`${activeUser.firstName} ${activeUser.lastName}`}
      className="rounded-circle me-2"
      width={40}
      height={40}
    />
  ) : (
    <PersonCircle
      size={40}
      className="me-2 bg-gray-500 text-white rounded-circle"
    />
  )}

  <div className="d-flex flex-column">
    <strong>
      {activeUser
        ? `${activeUser.firstName} ${activeUser.lastName}`
        : "Unknown User"}
    </strong>
    <small className="text-muted">
      {activeUser?.isConnected ? "Online" : "Offline"}
    </small>
  </div>
</div>

      <div className="flex-grow-1 overflow-auto bg-light p-3 rounded mb-3">
        {filteredMessages.length === 0 ? (
          <p className="text-center text-muted mt-3">No messages yet</p>
        ) : (
          filteredMessages.map((msg, idx) => {
            const isSender = msg.sender._id === userId;
            return (
              <div
                key={idx}
                className={`d-flex mb-3 ${
                  isSender ? "justify-content-end" : "justify-content-start"
                }`}
              >
                {!isSender && (
                  <div className="me-2">
                    {msg.sender.profilePhoto ? (
                      <img
                        src={msg.sender.profilePhoto}
                        alt={`${msg.sender.firstName} ${msg.sender.lastName}`}
                        className="me-2 bg-gray-500 text-white rounded-circle"
                        width={40}
                        height={40}
                      />
                    ) : (
                      <PersonCircle
                        size={40}
                        className="me-2 bg-gray-500 text-white rounded-circle"
                      />
                    )}
                  </div>
                )}
                <div
                  className={`rounded ${
                    !msg.file?.type?.startsWith("image")
                      ? isSender
                        ? "bg-gray-600 text-white p-2"
                        : "bg-gray-200 p-2"
                      : ""
                  }`}
                  style={{ maxWidth: "70%", fontSize: "0.9rem", lineHeight: "1.2" }}
                >
                  {msg.content && (
                    <p
                      className="mb-1"
                      style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                    >
                      {msg.content}
                    </p>
                  )}

                  {msg.file && msg.file.url && (
                    <>
                      {msg.file.type.startsWith("image") ? (
                        <img
                          src={msg.file.url}
                          alt="image"
                          className="img-fluid rounded"
                        />
                      ) : msg.file.type === "application/pdf" ? (
                        <a
                          href={msg.file.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-block"
                        >
                          📄 View PDF
                        </a>
                      ) : (
                        <a
                          href={msg.file.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-block"
                        >
                          📁 Download File
                        </a>
                      )}
                    </>
                  )}
                  <small className="text-muted d-block text-end">
                    {moment(msg.createdAt || msg.timestamp).format("LT")}
                  </small>
                </div>
              </div>
            );
          })
        )}
        {/* Empty div to scroll to */}
        <div ref={messagesEndRef} />
       <div ref={messagesEndRef} /> </div>

     <div
  className="position-fixed bottom-0 start-0 end-0 bg-white border-top p-2"
  style={{ zIndex: 1030 }}
>
  <Form
    onSubmit={(e) => {
      e.preventDefault();
      sendMessage(e);
    }}
    className="d-flex flex-wrap align-items-center gap-2"
  >
    {previewUrl && (
      <div style={{ flexShrink: 0 }}>
        {file?.type?.startsWith("image") ? (
          <img
            src={previewUrl}
            alt="preview"
            className="rounded"
            width={40}
            height={40}
          />
        ) : file?.type === "application/pdf" ? (
          <a
            href={previewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="d-block small"
          >
            📄 PDF Preview
          </a>
        ) : null}
      </div>
    )}

    <Form.Control
      as="textarea"
      rows={1}
      placeholder="Type your message..."
      value={message}
      onChange={(e) => setMessage(e.target.value)}
      ref={textareaRef}
      className="flex-grow-1 rounded-pill"
      style={{
        resize: "none",
        overflowY: "auto",
        maxHeight: "100px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        padding: "0.5rem 0.7rem",
        fontSize: "1rem",
        minWidth: "150px",
      }}
    />

    <div className="d-flex flex-wrap align-items-center gap-2">
      <select
        value={fromLanguage}
        onChange={(e) => setFromLanguage(e.target.value)}
        className="form-select"
        style={{
          width: "5.5rem",
          fontSize: "0.85rem",
          flexShrink: 0,
          borderRadius: "20px"
        }}
      >
           <option value="en">EN</option>
  <option value="ar">AR</option>
  <option value="de">DE</option>
  <option value="ru">RU</option>
  <option value="uk">UK</option>
  <option value="ku">KU</option>
  <option value="tr">TR</option>
      </select>

      <select
        value={toLanguage}
        onChange={(e) => setToLanguage(e.target.value)}
        className="form-select"
        style={{
          width: "5.5rem",
          fontSize: "0.85rem",
          flexShrink: 0,
          borderRadius: "20px"
        }}
      >
       
        <option value="en">EN</option>
  <option value="ar">AR</option>
  <option value="de">DE</option>
  <option value="ru">RU</option>
  <option value="uk">UK</option>
  <option value="ku">KU</option>
  <option value="tr">TR</option>
      </select>

      <label
        htmlFor="file-upload"
        className="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center"
        style={{ width: "38px", height: "38px", fontSize: "1rem" }}
      >
        <i className="fas fa-paperclip"></i>
      </label>
      <input
        id="file-upload"
        type="file"
        accept="image/*,.pdf"
        style={{ display: "none" }}
        onChange={handleFile}
      />

      <Button
        type="submit"
        variant="primary"
        className="rounded-circle p-2 d-flex align-items-center justify-content-center"
        style={{ width: "38px", height: "38px" }}
        disabled={sendingStatus === "sending"}
      >
        <i className="fas fa-paper-plane"></i>
      </Button>
    </div>

    {/* Status Messages */}
    <div className="w-100 text-end small mt-1">
      {sendingStatus === "sending" && (
        <span className="text-muted">Sending...</span>
      )}
      {sendingStatus === "sent" && (
        <span className="text-success">Sent ✓</span>
      )}
      {sendingStatus === "failed" && (
        <span className="text-danger">Failed to send</span>
      )}
    </div>
  </Form>
</div>

    </div>
  );
}